import { ReactElement, ReactNode, cloneElement } from "react";

const MenuIcon = ({ icon }: { icon: ReactNode }) => {
    const iconElement: ReactElement = icon as ReactElement;

    return cloneElement(iconElement, { ...iconElement.props, sx: { fontSize: 24, ...iconElement.props.sx } });
};

export default MenuIcon;
